import { render } from "@wordpress/element";

import FormIntegration from "./AdminComponent/FormIntegrationComponent";
import JobListComponent from "./FrontComponent/JobList/JobListComponent";

var appIntegration = document.getElementById("jobadder_integration");

if (appIntegration !== null) {
  const preElement = appIntegration.querySelector("pre") ?? "";
  const textContent = preElement.textContent.trim() ?? [];
  const JSONdata = JSON.parse(textContent);

  console.log(JSONdata, "appIntegration");
  render(<FormIntegration data={JSONdata} />, appIntegration);
}

var appRoot = document.getElementById("root-id-react-shorcode");

if (appRoot !== null) {
  const preElement = appRoot.querySelector("pre") ?? "";
  const textContent = preElement.textContent?.trim() ?? [];

  const JSONdata = textContent.length !== 0 ? JSON.parse(textContent) : [];

  if (JSONdata.widget === undefined) render(<></>, appRoot);

  if (JSONdata.widget === "joblist")
    render(<JobListComponent data={JSONdata} />, appRoot);
}

// Orignal
